var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailLinkLight = function SvgMailLinkLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E121B",
    d: "m17.728 16.032-1.273-1.274 1.273-1.273a4.5 4.5 0 1 0-6.364-6.364L10.09 8.395 8.818 7.122l1.274-1.272a6.3 6.3 0 1 1 8.91 8.91zm-2.546 2.546L13.91 19.85a6.3 6.3 0 0 1-8.91-8.91l1.273-1.272 1.273 1.274-1.273 1.272a4.5 4.5 0 1 0 6.364 6.364l1.273-1.272zm-.637-9.547 1.274 1.274-6.364 6.363-1.274-1.273 6.364-6.363"
  })));
};
export default SvgMailLinkLight;